<!--
  ~ Copyright (C) 2025 - present by Potentially
  ~
  ~ Please see distribution for license.
  -->

<div class="pdf-pages-renderer">
  @if (loading()) {
    <div class="pdf-loading">
      <mat-spinner [diameter]="24"></mat-spinner>
    </div>
  }

  @if (error()) {
    <div class="pdf-error">
      <a [href]="pdfUrl()" target="_blank">{{ pdfUrl() }}</a>
    </div>
  }

  @for (imageUrl of pageImageUrls(); track imageUrl) {
    <div class="pdf-page-wrapper">
      <img class="pdf-page-image" [src]="imageUrl" alt="PDF page" />
    </div>
  }
</div>
